<style scoped>
.flex-align-center {
  align-items: center;
}
.teacher-highlight {
  color: red;
}
.mu-flat-button {
  min-width: 0px;
}
.comment-wrapper {
  padding-left: 10px;
}
.reply-wrapper {
  padding-left: 36px;
}
.comment-container {
  padding: 4px;
}
.min-width-50 {
  min-width: 50%;
}
.mu-input {
  font-size: 12px;
}
.mu-icon-button.mu-button-small {
  width: 24px;
  height: 24px;
}
.mu-form-item .mu-button {
  margin: 3px 4px;
}
.mu-form-item {
  margin-bottom: 0px;
  padding-bottom: 0px;
  min-height: 0px;
}
.mu-flat-button.mu-button-small {
  font-size: 14px;
  height: 14px;
}
.tag-chip {
  margin-right: 4px;
  text-align: center;
}
.comment-name-wrapper {
  margin: 5px;
}
.comment-content {
  min-height: 20px;
}
.mu-chip {
  line-height: 14px;
}
</style>

<template>

<div class="component-wrapper comment-container">
  <div>
    <div v-if="!flagEditing">
      <div class="display-flex">
        <mu-avatar>
          <img :src="stringProfile" v-if="hasProfile">
          <img :src="defaultAvatar" v-else>
        </mu-avatar>
        <div>
        <b class="comment-name-wrapper" :class="classComment">{{stringCommentName}}</b>
        </div>
        <div v-show="this.stringTimestamp !== 'none'">
          <mu-chip class="tag-chip" :style="styleTag" @click.stop.prevent="onClickTimestamp" v-tooltip="$t('comment.jumpTo') + stringTimestamp" v-if="comment.hasOwnProperty('tag_id')">
            <span v-if="isVideo">
              {{ this.stringTimestamp + (comment.hasOwnProperty('timestampEnd') && comment.timestampEnd > 0 ? ' ~ ' + this.stringTimestampEnd : '') + ' - ' + (comment.tag ? comment.tag.name : '')}}
            </span>
            <span v-else>
              {{comment.tag ? comment.tag.name : ''}}
            </span>
          </mu-chip>
          <mu-chip class="tag-chip" :style="{color: 'red', 'background-color': 'transparent'}" @click.stop.prevent="onClickTimestamp" v-else-if="isVideo">
            {{ $t('comment.jumpTo')}}<br />{{ this.stringTimestamp }}
          </mu-chip>
        </div>
        <div class="flex-item min-width-50 comment-wrapper">
          <div>
            <span class="wordwrap" v-html="replaceUrl(comment.content)"></span>
          </div>
          <VoiceInput
            isSubmitted
            v-model="comment.audio"
            />
          <attachment-browser
            :initIds="comment.attachments"
            isSubmitted
            :simpleMode="true"
            />
          <mu-button 
            class="vertical-align-middle" 
            small flat 
            :color="comment.history && comment.history.length > 0 ? 'primary' : 'default'"
            @click="historyToggle = true"
            :disabled="!(comment.history && comment.history.length > 0)"
            >
            <small>{{stringCommentTime}}</small>
          </mu-button>
          <mu-button class="vertical-align-middle" small flat :color="comment.vote.upvoted ? 'primary' : ''" @click="onActionVote('upvote')" :disabled="comment.vote.downvoted || comment.vote.questioned"  v-tooltip="$t('vote.upvote')">
            <mu-icon class="vertical-align-middle" value="thumb_up" :size="14" style="margin-right: 2px;"/>
            {{comment.vote.upvote_count}}
          </mu-button>
          <small v-if="!isReply" style="vertical-align: text-bottom;">
            <mu-icon 
              size="14" 
              class="vertical-align-middle" 
              :value="typeIcon" />
              <span> {{typeString}}</span>
          </small>
          <mu-button style="vertical-align: text-top;" small flat @click="flagShowReply = !flagShowReply" v-show="!isReply">
            <mu-icon :value="flagShowReply ? 'keyboard_arrow_up' : 'keyboard_arrow_down'" :size="14"/>
            <small v-if="replies.length">{{replies.length}} {{$t('comment.repl' + ((replies.length > 1) ? 'ies' : 'y'))}}</small>
            <small v-else>{{$t('button.add') + $t('space') + $t('comment.reply')}}</small>
          </mu-button>
        </div>
        <BookmarkButton
          :id="comment._id"
          type="comment"
          :object="comment"
          :reference="media"
          small
          />
        <mu-menu cover v-show="isOwner || canDelete|| isAnnotate">
          <mu-button small icon>
            <mu-icon value="more_vert"></mu-icon>
          </mu-button>
          <mu-list slot="content">
            <mu-list-item button @click="flagEditing = true" v-if="isOwner || isAnnotate">
              <mu-list-item-action>
                <mu-icon value="edit" />
              </mu-list-item-action>
              <mu-list-item-title>{{$t('button.edit')}}</mu-list-item-title>
            </mu-list-item>
            <mu-list-item button @click="onClickDelete" v-if="canDelete || isOwner">
              <mu-list-item-action>
                <mu-icon value="delete" />
              </mu-list-item-action>
              <mu-list-item-title>{{$t('button.delete')}}</mu-list-item-title>
            </mu-list-item>
          </mu-list>
        </mu-menu>
      </div>
    </div>
    <mu-form :model="form" v-else>
      <mu-form-item prop="input">
        <mu-text-field multi-line :rows="1" :rows-max="6" v-model="comment.content" :disabled="!media.comment_mode && comment.hasOwnProperty('tag_id')">
          <div v-show="this.stringTimestamp !== 'none' && isVideo" slot="prepend">
            <mu-chip class="tag-chip" :style="styleTag" @click.stop.prevent="onClickTimestamp" v-tooltip="$t('comment.jumpTo') + stringTimestamp" v-if="comment.hasOwnProperty('tag_id')">
              {{ comment.tag.name }}
            </mu-chip>
          </div>
          <TimestampInput v-model="comment.timestamp" slot="prepend" v-if="!isReply"/>
          <b slot="prepend" v-if="comment.hasOwnProperty('tag_id') && comment.hasOwnProperty('timestampEnd') && comment.timestampEnd > 0 && !isReply"> ~ </b>
          <span slot="prepend" style="padding-right: 10px;">
            <TimestampInput
              v-model="comment.timestampEnd" 
              v-if="comment.hasOwnProperty('tag_id') && comment.hasOwnProperty('timestampEnd') && comment.timestampEnd > 0 && !isReply"
              />
          </span>
          <mu-button slot="append" icon small @click="onActionEdit"><mu-icon value="check"></mu-icon></mu-button>
          <mu-button slot="append" icon small @click="onActionCancel"><mu-icon value="close"></mu-icon></mu-button>
          <emoji-picker @emoji="insertEdit" :search="search" slot="append">
            <mu-button icon small slot="emoji-invoker"
            slot-scope="{ events }"
            v-on="events"><mu-icon value="face" /></mu-button>
            <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
            <div class="emoji-picker" :style="{ right: '50px', bottom: '0px' }">
              <div class="emoji-picker__search">
              <input type="text" v-model="search">
              </div>
              <div>
              <div v-for="(emojiGroup, category) in emojis" :key="category">
                <h5>{{ category }}</h5>
                <div class="emojis">
                <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                </div>
              </div>
              </div>
            </div>
            </div>
          </emoji-picker>
        </mu-text-field>
        <VoiceInput
          v-if="comment.audio"
          v-model="comment.audio"
          />
        <attachment-browser 
          class="full-width" 
          v-if="comment.attachments && !comment.hasOwnProperty('tag_id')" 
          :initIds="comment.attachments" 
          @onUpdateAttachments="onUpdateAttachments" 
          :isSubmitted="false"/>
      </mu-form-item>
    </mu-form>
  </div>
  <transition-group name="list" tag="div">
    <div :key="1" class="reply-wrapper" v-show="flagFetchedReplies && flagShowReply">
      <transition-group name="list" tag="div">
        <comment-item
          :mediaType="mediaType"
          :media="media"
          :isReply="constTrue"
          :comment="reply"
          :adminUserIds="adminUserIds"
          v-for="(reply, i) in replies"
          :key="reply._id"
          :index="i"
          @onFinishedDelete="onFinishedDelete(i)"
          @onUpdate="onUpdate" />
      </transition-group>
    </div>
    <div v-if="!isReply && flagShowReply" :key="0" class="reply-wrapper">
      <mu-form :model="form">
        <mu-form-item prop="input" ref="replyField">
          <mu-text-field
            multi-line :rows="1" :rows-max="3"
            v-model="modelReply"
            :placeholder="$t('button.add') + $t('space') + $t('comment.reply') + '...'"
            @change="onAutoSave(modelReply)"
            >
            <transition name="fade">
              <mu-button icon small type="submit" @click.stop.prevent="onCheckInput" v-if="typeof this.modelReply === 'string' && this.modelReply !== ''"><mu-icon value="send"/></mu-button>
            </transition>
            <mu-checkbox v-model="modelAnomymous" :label="$t('comment.anomymous')" slot="append" v-if="anomymous"/>
            <emoji-picker @emoji="insert" :search="search" slot="append">
              <mu-button icon small slot="emoji-invoker"
              slot-scope="{ events }"
              v-on="events"><mu-icon value="face" /></mu-button>
              <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
              <div class="emoji-picker" :style="{ right: '50px', bottom: '0px' }">
                <div class="emoji-picker__search">
                <input type="text" v-model="search">
                </div>
                <div>
                <div v-for="(emojiGroup, category) in emojis" :key="category">
                  <h5>{{ category }}</h5>
                  <div class="emojis">
                  <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                  </div>
                </div>
                </div>
              </div>
              </div>
            </emoji-picker>
            <mu-button
              small icon
              :color="voiceCollapse ? 'primary' : ''"
              @click.stop.prevent="voiceCollapse = !voiceCollapse"
              slot="append"
              >
              <mu-icon value="mic" />
            </mu-button>
            <mu-button small icon :color="attachmentCollapse ? 'primary' : ''" @click.stop.prevent="attachmentCollapse = !attachmentCollapse" v-tooltip="$t('comment.attachment')" slot="append"><mu-icon value="attachment" /></mu-button>
            <mu-button icon small slot="prepend">
              <mu-icon value="reply"/>
            </mu-button>
          </mu-text-field>
          <VoiceInput
            v-if="voiceCollapse"
            v-model="modelAudio"
            />
          <attachment-browser class="full-width" v-if="attachmentCollapse" @onUpdateAttachments="onUpdateReplyAttachments" :isSubmitted="false" :initIds="modelAttachment" />
        </mu-form-item>
      </mu-form>
    </div>
  </transition-group>

  <mu-dialog :title="$t('button.delete') + $t('space') + $t('comment.title')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="flagDialogDelete = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
  <mu-dialog :title="$t('comment.history')" width="360" scrollable :open.sync="historyToggle">
    <div :key="index" v-for="(history, index) in computedHistory" style="padding-bottom: 10px;">
      <div><span v-html="stringDiff(history.before, history.after)"></span></div>
      <small>{{history.name}}, {{stringEditedTime(history.time * 1000)}}</small>
    </div>
    <mu-button slot="actions" flat color="primary" @click="historyToggle = false">
      <mu-icon value="check" />
    </mu-button>
  </mu-dialog>
</div>

</template>

<script>
// Library
import axios from 'axios'

import lastTimeAt from '@/utils/lastTimeAt.js'
import timeFormatter from '@/utils/timeFormatter.js'

// Assets
import defaultAvatar from '@/assets/img/default_avatar.png'

// Library
import EmojiPicker from 'vue-emoji-picker'
import diff from 'fast-diff'

// Components
import AttachmentBrowser from '@/components/Common/AttachmentBrowser.vue'
import TimestampInput from '@/components/Common/TimestampInput.vue'
import VoiceInput from '@/components/Common/VoiceInput.vue'
import BookmarkButton from '@/components/Bookmark/Button.vue'

export default {
  name: 'CommentItem',
  components: {
    EmojiPicker,
    AttachmentBrowser,
    TimestampInput,
    VoiceInput,
    BookmarkButton,
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    isReply: {
      type: Boolean,
      default: false
    },
    mediaType: {
      type: String,
      required: true
    },
    media: {
      type: Object,
      required: true
    },
    adminUserIds: {
      type: Array,
      default() {
        return [];
      }
    },
    anomymous: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // Object
      replies: [], // Replies list object
      vote: {}, // Vote count object
      search: '',

      // Flag
      flagDialogDelete: false, // Boolean variable for status of delete dialog
      flagDialogReply: false, // Boolean variable for status of reply dialog
      flagFetchedReplies: false, // Boolean variable for status of fetching replies
      flagFetchedVote: false, // Boolean variable for status of fetching vote
      flagSending: false, // Boolean variable for status of sending
      flagEditing: false, // Boolean variable for status of editing
      flagShowReply: false,
      attachmentCollapse: false,
      voiceCollapse: false,
      historyToggle: false,

      // Message
      msgDelete: "", // More message showing when deleting comment with replies

      // Model
      modelReply: "", // Bind with reply input
      modelAnomymous: false,
      modelAttachment: [],
      modelAudio: [],
      form: {},
    }
  },
  computed: {
    // Asset
    defaultAvatar() {
      return defaultAvatar;
    },
    
    computedHistory() {
      if(this.comment.hasOwnProperty('history') && Array.isArray(this.comment.history)) {
        return this.comment.history.reverse();
      } else {
        return [];  
      }
    },
    
    // Type
    typeIcon() {
      if(this.comment.hasOwnProperty('tag_id')) {
        return 'local_offer';
      } else if(this.modelType === 'comment') {
        return 'comment';
      } else if (this.modelType === 'question') {
        return 'question_answer';
      } else if (this.modelType === 'annotation') {
        return 'sms';
      }
    },
    typeColor() {
      if(this.modelType === 'comment') {
        return 'primary';
      } else if (this.modelType === 'question') {
        return 'secondary';
      } else if (this.modelType === 'annotation') {
        return 'success';
      }
    },
    typeString() {
      if(this.comment.hasOwnProperty('tag_id')) {
        return this.$t('vote.display');
      } else if(this.modelType === 'comment') {
        return this.$t('comment.mode.comment') ;
      } else if (this.modelType === 'question') {
        return this.$t('comment.mode.question') ;
      } else if (this.modelType === 'annotation') {
        return this.$t('comment.mode.annotation') ;
      }
    },
    typeOptions() {
      var arr = [
        { value: 'question', text: this.$t('comment.mode.question') },
        { value: 'comment', text: this.$t('comment.mode.comment') },
        { value: 'annotation', text: this.$t('comment.mode.annotation') },
      ];
      return arr;
    },

    // Flag
    isOwner() {
      return this.comment.user_id === this.$store.state.auth.user._id;
    },
    isTeacher() {
      return this.adminUserIds.includes(this.comment.user_id);
    },
    canDelete() {
      return this.adminUserIds.includes(this.$store.state.auth.user._id) && !this.adminUserIds.includes(this.comment.user_id);
    },
    isVideo() {
     return this.mediaType === "video" || this.mediaType === "youtube" || this.mediaType === "mp4link";
    },
    isAnnotate() {
      return this.comment.type === 'annotation';
    },
    hasProfile() {
      if(this.comment.user.hasOwnProperty('profile')) {
        if(this.comment.user.profile === '' || this.comment.anomymous) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isQuestion() {
      if(this.comment.hasOwnProperty('question')) {
        return this.comment.question;
      } else {
        return false;
      }
    },

    // Class
    classComment() {
      if(this.comment.anomymous) {
        return '';
      } else {
        if(this.isTeacher) {
          return 'teacher-highlight';
        } else {
          return '';
        }
      }
    },

    // String
    stringShortAvatar() {
      if(this.comment.user.hasOwnProperty('name')) {
        return this.comment.user.name.substring(0, 1);
      } else {
        return this.comment.user.username.substring(0, 1);
      }
    },
    stringType() {
      if (this.isReply) {
        return this.$t('comment.reply');
      } else {
        return this.$t('comment.title');
      }
    },
    stringCommentName() {
      if(this.comment.anomymous) {
        return this.$t('comment.anomymous');
      } else {
        if(this.comment.user.hasOwnProperty('name')) {
          return this.comment.user.name;
        } else {
          return this.comment.user.username;
        }
      }
    },
    stringFormattedTime() {
      var d;
      if (this.comment.updated_at === this.comment.created_at) {
        d = new Date(this.comment.created_at);
      } else {
        d = new Date(this.comment.updated_at);
      }
      var str = d.toISOString();
      return str;
    },
    stringCommentTime() {
      var time, prefix;
      if (this.comment.updated_at === this.comment.created_at) {
        time = lastTimeAt(this.comment.created_at);
        prefix = "";
      } else {
        time = lastTimeAt(this.comment.updated_at);
        prefix = this.$t('comment.update');
      }
      return prefix + time.value + this.$t(time.suffix);
    },
    stringProfile() {
      return this.$store.getters.urlStorage + "profile/" + this.comment.user.profile;
    },
    stringDelete() {
      if (this.isReply && (this.replies === "" || this.replies.length <= 0)) {
        return this.$t('prompt.deleteMsg', { name: this.$t('comment.thisReply') }) + this.msgDelete;
      } else {
        return this.$t('prompt.deleteMsg', { name: this.$t('comment.thisComment') }) + this.msgDelete;
      }
    },
    stringTimestamp() {
      if (this.comment.timestamp !== undefined && this.comment.timestamp !== null) {
        return timeFormatter(this.comment.timestamp);
      } else {
        return "none";
      }
    },
    stringTimestampEnd() {
      if (this.comment.hasOwnProperty('timestampEnd') && this.comment.timestampEnd !== null) {
        return timeFormatter(this.comment.timestampEnd);
      } else {
        return "none";
      }
    },
    stringColor() {
      if(this.comment.hasOwnProperty('tag_id') && this.comment.hasOwnProperty('tag')) {
        if (typeof this.comment.tag.color != 'undefined')
          return "rgba(" + this.comment.tag.color.r + ", " + this.comment.tag.color.g + ", " + this.comment.tag.color.b + ", " + this.comment.tag.color.a + ")";
        else
          return "rgba(255,255,255,1)";
      } else {
        return "rgba(255,255,255,1)";
      }
    },
    stringBgColor() {
      if(this.comment.hasOwnProperty('tag_id') && this.comment.hasOwnProperty('tag')) {
        if (typeof this.comment.tag.backgroundColor != 'undefined')
          return "rgba(" + this.comment.tag.backgroundColor.r + ", " + this.comment.tag.backgroundColor.g + ", " + this.comment.tag.backgroundColor.b + ", " + this.comment.tag.backgroundColor.a + ")";
        else
          return "rgba(0,0,0,0.5)";
      } else {
        return "rgba(255,255,255,1)";
      }
    },

    // Class
    classUpvote() {
      return {
        'md-primary': this.comment.vote.upvoted
      }
    },
    classQuestion() {
      return {

      }
    },
    classDownvote() {
      return {
        'md-accent': this.comment.vote.downvoted
      }
    },

    // Style
    styleTag() {
      return {
        color: this.stringColor,
        backgroundColor: this.stringBgColor
      };
    },

    // Constant
    constTrue() {
      return true;
    },

    // Model
    modelType: {
      get() {
        if(this.comment.hasOwnProperty('type')) {
          return this.comment.type;
        } else {
          return 'comment';
        }
      },
      set(newValue) {
        this.comment.type = newValue;
      }
    }
  },
  watch: {
    flagShowReply(newValue) {
      if(newValue && !this.flagFetchedReplies) {
        this.fetchReplies();
      }
    },
    anomymous() {
      this.modelAnomymous = false;
    },
  },
  mounted() {
    this.fetchReplies();
    this.initAutoSave();
  },
  methods: {
    // Fetch
    fetchReplies() { // Fetch replies of comment
      if (!this.comment.hasOwnProperty('comment_id')) {
        axios.get(this.$store.getters.urlApi + "comment/comment/" + this.comment._id, {
          headers: {
            token: this.$store.state.auth.token
          }
          }
        ).then(response => {
          this.replies = response.data.data.comments
          this.flagFetchedReplies = true;
          if(this.replies.length > 0) {
            this.flagShowReply = true;
          }
        });
      }
    },

    initAutoSave() {
      if (typeof(Storage) !== "undefined" && typeof(localStorage.getItem("reply-" + this.comment._id)) === "string") {
        // Code for localStorage/sessionStorage.
        this.modelReply = localStorage.getItem("reply-" + this.comment._id);
      } else {
        // Sorry! No Web Storage support..
        this.modelReply = ""
      }
    },
    onAutoSave(str) {
      if (typeof(Storage) !== "undefined") {
        // Code for localStorage/sessionStorage.
        localStorage.setItem("reply-" + this.comment._id, str);
      } else {
        // Sorry! No Web Storage support..
      }
    },

    // Event
    onClickDelete() {
      if (this.isReply || this.replies === "" || this.replies.length <= 0) {
        this.msgDelete = "";
      } else {
        this.msgDelete = "" + this.$t('comment.deleteReplyMsg');
      }
      this.flagDialogDelete = true;
    },
    onClickReply() {
      this.flagDialogReply = !this.flagDialogReply;
      if(this.flagDialogReply) {
        this.$nextTick(() => {
          this.$refs.replyField.$el.getElementsByTagName("input")[0].focus();
        });
      }
    },
    onActionDelete() {
      axios.delete(this.$store.getters.urlApi + "comment/" + this.comment._id, {
        headers: {
          token: this.$store.state.auth.token
        },
        params: {
          'ids': this.attachmentIds
        }
        }
      ).then(() => {
        this.$emit("onFinishedDelete", this.index);
        this.$toast.success(this.$t('toast.delete'));
      });
    },
    onFinishedDelete(i) {
      this.$delete(this.replies, i);
      this.fetchReplies();
    },
    onActionEdit() { // Edit action handler
      this.flagEditing = false;
      axios.put(this.$store.getters.urlApi + "comment/" + this.comment._id, {
          'content': this.comment.content,
          'timestamp': this.comment.timestamp,
          'timestampEnd': this.comment.timestampEnd,
          'type': this.modelType
        }, {
          headers: {
            token: this.$store.state.auth.token,
            'content-type': 'application/json'
          },
        }
      ).then(() => {
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onUpdateAttachments(payload) {
      this.comment.attachments = payload;
      axios.put(this.$store.getters.urlApi + "comment/" + this.comment._id, {
          'attachments': this.comment.attachments
        }, {
          headers: {
            token: this.$store.state.auth.token,
            'content-type': 'application/json'
          },
        }
      ).then(() => {
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onActionCancel() {
      this.flagEditing = false;
    },
    onKeyUp(e) { // On key up handler
      if (e.keyCode === 13) {
        this.onCheckInput();
      }
    },
    onCheckInput() { // Validator of comment input
      if (this.modelReply === "") {
        this.$toastr.error(this.$t('comment.emptyReplyMsg'));
      } else {
        this.onActionReply();
      }
    },
    onActionReply() { // Add reply action handler
      if (!this.flagSending) {
        this.flagSending = true;
        axios.post(this.$store.getters.urlApi + "comment/comment/" + this.comment._id, {
            'content': this.modelReply,
            'anomymous': this.modelAnomymous,
            'attachments': this.modelAttachment,
          }, {
          headers: {
            token: this.$store.state.auth.token,
            'content-type': 'application/json'
          },
          }
        ).then(() => {
          this.modelReply = "";
          this.modelAnomymous = false;
          this.onAutoSave(this.modelReply);
          this.flagDialogReply = false;
          this.fetchReplies();
          this.flagSending = false;
          this.modelAttachment = [];
          this.attachmentCollapse = false;
          this.$toast.success(this.$t('toast.create'));
        });
      }
    },
    onActionVote(type) {
      if (this.comment.vote.upvoted || this.comment.vote.downvoted || this.comment.vote.questioned) {
        axios.delete(this.$store.getters.urlApi + "vote/comment/" + this.comment._id, {
          headers: {
            token: this.$store.state.auth.token
          },
          params: {
            'ids': this.attachmentIds
          }
          }
        ).then(() => {
          this.onUpdate();
        });
      } else {
        axios.post(this.$store.getters.urlApi + "vote/comment/" + this.comment._id, {
            'type': type
          }, {
          headers: {
            token: this.$store.state.auth.token,
            'content-type': 'application/json'
          },
          }
        ).then(() => {
          this.onUpdate();
        });
      }
    },
    onClickTimestamp() {
      this.$emit('onClickTimestamp', this.comment.timestamp);
    },
    onUpdate() {
      this.$emit('onUpdate');
      this.fetchReplies();
    },
    onUpdateReplyAttachments(payload) {
      this.modelAttachment = payload;
    },

    replaceUrl(text) {
      if(typeof text === "string") {
        var re = /(?![^<]*>|[^<>]*<\/)((https?:)\/\/[a-z0-9&#=.\/\-?_:]+)/gi;
        var val = re.exec(text);
        var subst = '<a href="$1" target="_blank">$1</a>';
        var result = text.replace(re, subst);
        return result;
      } else {
        return result;
      }
    },

    // Emoji
    insert(emoji) {
      this.modelReply += emoji
    },
    insertEdit(emoji) {
      this.comment.content += emoji
    },
    
    stringDiff(before, after) {
      var html = '';
      var result = diff(before, after);
      result.forEach(item => {
        var type = item[0];
        var content = item[1];
        if(type === diff.INSERT) {
          html += '<span style="color: red">' + content + '</span>';
        } else if(type === diff.DELETE) {
          html += '<span style="text-decoration: line-through">' + content + '</span>';
        } else if(type === diff.EQUAL) {
          html += '<span>' + content + '</span>';
        }
      });
      return html;
    },
    stringEditedTime(time) {
      var t = lastTimeAt(time);
      return t.value + this.$t(t.suffix);
    },
  },
}
</script>
1234
1245
